import { render } from "./PatientResultFiles.vue?vue&type=template&id=44f35d04"
import script from "./PatientResultFiles.vue?vue&type=script&lang=js"
export * from "./PatientResultFiles.vue?vue&type=script&lang=js"

import "./PatientResultFiles.vue?vue&type=style&index=0&id=44f35d04&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__